import { FC } from 'react';
import { UserRoleObject } from '@/types';

const RoleBadge: FC<{ role?: UserRoleObject }> = ({ role }) => {
  const roleConfig: Record<string, { bg: string; text: string }> = {
    admin: { bg: 'bg-purple-100', text: 'text-purple-800' },
    superadmin: { bg: 'bg-blue-100', text: 'text-blue-800' },
    app: { bg: 'bg-gray-100', text: 'text-gray-800' },
    agent: { bg: 'bg-green-100', text: 'text-green-800' },
    contentManager: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
    defaultRole: { bg: 'bg-gray-100', text: 'text-gray-800' }
  };

  const config = role ? roleConfig[role.code] ||  roleConfig['defaultRole'] :  roleConfig['defaultRole'];

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.bg} ${config.text}`}>
      {role?.name}
    </span>
  );
};

export default RoleBadge;
